module.exports = __webpack_public_path__ + "assets/img/teacher (18).18e1bc52.png";